import React, { useEffect, useState } from 'react';
import './AssessmentCrud.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import sortByAssessmentName from '../sortingHelper';


const config=require( '../../config.js');

function AssessmentCrud() {
    const [assessments, setAssessments] = useState([]);
    const navigate = useNavigate();

    const fetchAssessments = async () => {
        try {
            const response = await fetch(config.env.API_BASE_URL + '/api/assessments', {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                const data = await response.json();
                setAssessments(data);
            } else {
                console.error('Failed to fetch assessments');
            }
        } catch (error) {
            console.error('Error fetching assessments:', error);
        }
    };

    useEffect(() => {
        fetchAssessments(); // Fetch assessments on component mount
    }, []);


    const handleUpdate = (assessment) => {
        navigate(`/update/${assessment._id}`, { state: { assessment } });
    };

    const handleCopy = async (assessment) => {
        const assessmentData = {
            examName: "Copy of " + assessment.examName,
            examCategory: assessment.examCategory,
            language: assessment.language,
            questions: assessment.questions,
        };
        try {
            const response = await fetch(config.env.API_BASE_URL+'/api/assessments', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(assessmentData)
            });

            if (response.ok) {
                alert('Assessment copied successfully!');
                fetchAssessments(); // Refresh the list of assessments
            } else {
                const errorData = await response.text();
                alert(`Failed to save assessment: ${errorData}`);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while saving the assessment.');
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/assessments/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                setAssessments(assessments.filter(assessment => assessment._id !== id));
                alert('Assessment deleted successfully');
            } else {
                console.error('Failed to delete assessment');
            }
        } catch (error) {
            console.error('Error deleting assessment:', error);
        }
    };



    return (
        <>
            <div className='d-flex container justify-content-end'>
                <button className='btn-Create mt-3' onClick={() => navigate('/create')}>
                    Create Assessment
                </button>
            </div>
            <div className='mt-5 Crud-main-container container'>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col" className='text-start'>Name</th>
                            <th scope="col">Category</th>
                            <th scope="col">Language</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assessments
                            .slice()
                            .sort(sortByAssessmentName)
                            .map((assessment) => (
                                <tr key={assessment._id}>
                                    <td className='w-50 text-start'>{assessment.examName}</td>
                                    <td>{assessment.examCategory}</td>
                                    <td>{assessment.language}</td>
                                    <td>
                                        <FontAwesomeIcon
                                            onClick={() => handleUpdate(assessment)}
                                            className='icon'
                                            icon={faPenToSquare}
                                        />
                                        <FontAwesomeIcon
                                            onClick={() => handleCopy(assessment)}
                                            className='icon'
                                            icon={faCopy}
                                        />
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if (window.confirm('Are you sure you want to delete this assessment?')) {
                                                    handleDelete(assessment._id);
                                                }
                                            }}
                                            className='icon trash'
                                            icon={faTrashCan}
                                        />
                                    </td>
                                </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default AssessmentCrud;
